import { HALApiService } from './hal-api.service'
import { createItemsData } from '../utils/request.utils'
import { Service } from './base-service'

class StoragePlacesService extends Service {
  identifierCapabilities() {
    if (!this._identifierCapabilityRequest) {
      this._identifierCapabilityRequest = this._httpClient.get('/storage/place-identifiers')
        .finally(() => { this._identifierCapabilityRequest = null; });
    }
    return this._identifierCapabilityRequest;
  }

  identifierRequest(data) {
    return this._httpClient.saveRequest('/storage/place-identifiers', data);
  }

  constructor (httpClient, middleware) {
    super('/storage/place', httpClient, middleware)
  }
}

export const storagePlacesService = new StoragePlacesService(HALApiService, createItemsData)
